import React from 'react';
import './about.css';
import photo from './photo.png';
import Aos from 'aos';
import 'aos/dist/aos.css';
import { useEffect } from 'react';
import {BrowserRouter as Router} from 'react-router-dom';
import { HashLink as Link} from 'react-router-hash-link';
const About= () => {
useEffect(()=>{
 Aos.init({
   duration: 2000,
    
  });
},[]);
    return(
      <Router>
        <section  data-aos= 'flip-up' className='about' id='aboutme' >
           <div className='about__me'>
             <p>Hi, my name is  </p>
             <span className='about__name'>Kenneth Bett</span>
              <div className="i-title">
            <div className="i-title-wrapper">
              <div className="i-title-item">Web Developer</div>
              <div className="i-title-item">UI/UX Designer</div>
              <div className="i-title-item">Photographer</div>
              <div className="i-title-item">Writer</div>
              <div className="i-title-item">Content Creator</div>
            </div> </div>        
             <pre>I design and develop services for customers<br/> 
               of all sizes, specializing in web<br />
             applications with great user experience</pre>

             <button className='btn'>
             <Link to="#contact" smooth>
            Contact
        </Link>
             </button>
           </div>
           <div className='about__card'>
            <img src={photo} loading='lazy' alt='my_photo' />
             <div className='about__clip'>
               
             </div>
           </div>
            
        </section>
        </Router>
    );
}

export default React.memo(About);